export default "__VITE_ASSET__CKXI9RlK__"